import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Loanscheme } from "./loanscheme.model";

@Injectable({
  providedIn: 'root'
})

export class LoanschemeService {

  selectedLoanScheme: Loanscheme;
  LoanSchemeList: Loanscheme[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDLoanScheme(loanscheme: Loanscheme) {

    loanscheme.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loanscheme.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loanscheme.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loanscheme.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = loanscheme;
    console.log(loanscheme);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loanscheme/IUD', body, { headers: headers });
  }

  GetAccountGroupList() {

    this.selectedLoanScheme = new Loanscheme();
    this.selectedLoanScheme.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoanScheme.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoanScheme.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoanScheme.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AccountGroup', body, { headers: headers });
   }

  FetchLoanSchemeById(loanscheme) {

    loanscheme.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loanscheme.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loanscheme.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loanscheme.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = loanscheme;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loanscheme/Fetch', body, { headers: headers });
  }

  //-----------------------------FetchGroupList----Component-------------------------------------
  FetchLoanSchemeList() {

    this.selectedLoanScheme = new Loanscheme();
    this.selectedLoanScheme.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoanScheme.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoanScheme.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoanScheme.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoanScheme;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loanscheme/FetchList', body, { headers: headers });
  }

  // GetCategoryList() {
  //   let body = '';
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Category', body, { headers: headers });
  // }

  FetchLoanType() {
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanType', body, { headers: headers });
  }

  FetchLoanCategory() {
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanCategory', body, { headers: headers });
  }

  FetchPeriodType(){
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanTypePeriod', body, { headers: headers });
  }

}

